const bus = require('sci/std/bus')
const R = require('ramda')

module.exports = (formName, promise) => {
    return promise.then((x) => {
        bus.putErrors(formName, [])

        return x
    }).catch((ex) => {
        const errors = ex.errors

        const namedErrors = (errors || []).reduce((all, e) => {
            const key = formName + '^' + e.dataPath

            if (!all.hasOwnProperty(key)) {
                all[key] = []
            }

            return {
                ...all,
                [key]: all[key].concat([e])
            }
        }, {})

        bus.putErrors(formName, R.toPairs(namedErrors))

        throw ex
    })
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/new-chaos.js